import { Flex, Title, Tooltip } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import { OptionEntity } from '@/types/OptionEntity';

import BaseClickable from '../BaseClickable';

import s from './Tabs.module.scss';

export type TabData = OptionEntity & {
  disabled?: boolean;
  disabledTooltip?: string;
};

export type Props = {
  items: TabData[];
  activeKey: string | null;
  onChange: (key: string) => void;
};

const Tabs: React.FC<Props> = ({ items, activeKey, onChange }) => {
  return (
    <Flex className={s.root} align="center" gap="md">
      {items.map((item) => {
        const isActive = activeKey === item.key;

        const tabButton = (
          <BaseClickable
            withHover
            disabled={item.disabled}
            className={cn(s.root__tab, isActive && s.root__tab_active, item.disabled && s.root__tab_disabled)}
            onClickWithValue={onChange}
            value={item.key}
          >
            <Title size="h5">{item.value}</Title>
          </BaseClickable>
        );

        if (item.disabled && item.disabledTooltip) {
          return (
            <Tooltip
              key={item.key}
              withinPortal
              label={item.disabledTooltip}
              disabled={!item.disabled}
              position="bottom"
            >
              <div>{tabButton}</div>
            </Tooltip>
          );
        }

        return <React.Fragment key={item.key}>{tabButton}</React.Fragment>;
      })}
    </Flex>
  );
};

export default React.memo(Tabs);
